import React from 'react';
import { motion } from 'framer-motion';
import '@/components/ui/PageBanner.scss';

interface PageBannerProps {
  title: string;
  subtitle?: string;
  image: string;
}

const PageBanner: React.FC<PageBannerProps> = ({ title, subtitle, image }) => {
  return (
    <motion.div
      className="hero-banner"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5, ease: 'easeInOut' }}
    >
      <img src={image} alt={title} className="hero-banner__image" />
      <motion.div
        className="hero-banner__overlay"
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
      >
        {subtitle && <h4 className="hero-banner__subtitle">{subtitle}</h4>}
        <h1 className="hero-banner__title">{title}</h1>
      </motion.div>
    </motion.div>
  );
};

export default PageBanner;
